<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div>
            <b-modal id="modal" :title="referralNote" ref="referral-modal">
                <div class="row">
                    <div class="col-md-12">
                        <p class="mb-3">{{ modalContent }}</p>
                    </div>
                </div>
            </b-modal>
        </div>
        <div v-if="isLoading" class="loader-overlay">
            <div class="spinner"></div>
        </div>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">{{ $t('properties_list.View_Properties') }}</h4>
                        <div class="search-bar mb-3 search-bar-style">
                            <b>{{ $t('common.search') }}: </b>
                            <input style="border: 1px solid #dcdfe6;" type="text" v-model="serverParams.search"
                                @input="onSearch" :placeholder="$t('common.search_placeholder')" />
                        </div>
                    </div>
                    <div class="card-body">
                        <vue-good-table mode="remote" :rows="rows" :columns="columns" :totalRows="totalRecords"
                            @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange" :sort-options="{ enabled: true }" :pagination-options="{
                                enabled: true,
                                dropdownAllowAll: false,
                                perPageDropdown: [10, 20, 50, 100, 200],
                                nextLabel: $t('pagination.next'),
                                prevLabel: $t('pagination.Previous'),
                                rowsPerPageLabel: $t('pagination.rowsPerPage'),
                                ofLabel: $t('pagination.of'),
                            }">

                            <template slot="table-row" slot-scope="props">

                                <span v-if="props.column.field == 'property_type'">
                                    <span>{{ $t('property_detail.' + props.row.property_type) }}</span>
                                </span>
                                <span v-if="props.column.field == 'city'">
                                    <span> {{ props.row["city" + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'state'">
                                    <span>{{ props.row["state" + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'status'">
                                    <span v-if="props.column.field === 'status' && props.row.approve === 1">
                                        {{ $t('property_detail.approved') }}
                                    </span>
                                    <span v-else>
                                        <!-- Not Approved -->
                                        <b-button size="sm" @click="approveProperty(props.row.id)"
                                            class="mr-1 btn-info text-white">
                                            {{ $t('property_detail.Approve') }}
                                        </b-button>
                                    </span>
                                </span>
                                <span v-if="props.column.field === 'social_publish_status'">

                                    <!-- DO NOT PUBLISH -->
                                    <span v-if="props.row.social_publish_status === 'do_not_publish'"
                                        class="badge badge-secondary">
                                        {{ $t('social_publish.do_not_publish') }}
                                    </span>

                                    <!-- READY TO PUBLISH -->
                                    <span v-else-if="props.row.social_publish_status === 'ready_to_publish'"
                                        class="badge badge-warning">
                                        {{ $t('social_publish.ready_to_publish') }}
                                    </span>

                                    <!-- PUBLISHED -->
                                    <span v-else-if="props.row.social_publish_status === 'published'"
                                        class="badge badge-success">
                                        {{ $t('social_publish.published') }}
                                    </span>

                                </span>

                                <span v-if="props.column.field === 'action'" class="text-nowrap">

                                    <button size="sm" @click="propertyDetail(props.row.id)"
                                        class="btn mr-1 new-view-btn custom-btn">
                                        <!-- {{ $t('properties_list.Detail') }} -->
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="17"
                                            height="17" fill="white">
                                            <path
                                                d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
                                        </svg>
                                    </button>
                                    <button size="sm" @click="deleteProperty(props.row.id)"
                                        class="btn mr-1 new-del-btn custom-btn">
                                        <!-- {{ $t('properties_list.Delete') }} -->
                                        <svg width="15" height="20" viewBox="0 0 15 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.5"
                                                d="M13.7483 3.50285H9.41832V2.72285C9.41832 1.73285 8.60832 0.922852 7.61832 0.922852C6.62832 0.922852 5.81832 1.73285 5.81832 2.72285V3.50285H1.49832C0.82832 3.50285 0.27832 4.04285 0.27832 4.72285C0.27832 5.40285 0.81832 5.94285 1.49832 5.94285H13.7583C14.4283 5.94285 14.9783 5.39285 14.9783 4.72285C14.9783 4.05285 14.4283 3.50285 13.7583 3.50285H13.7483ZM1.41832 17.5029C1.41832 18.7229 2.40832 19.7029 3.61832 19.7029H11.6183C12.8383 19.7029 13.8183 18.7129 13.8183 17.5029V7.31285H1.41832V17.5029ZM8.78832 10.2529C8.78832 9.83285 9.12832 9.49285 9.54832 9.49285C9.96832 9.49285 10.3083 9.83285 10.3083 10.2529V16.7229C10.3083 17.1429 9.96832 17.4829 9.54832 17.4829C9.12832 17.4829 8.78832 17.1429 8.78832 16.7229V10.2529ZM4.93832 10.2529C4.93832 9.83285 5.27832 9.49285 5.69832 9.49285C6.11832 9.49285 6.45832 9.83285 6.45832 10.2529V16.7229C6.45832 17.1429 6.11832 17.4829 5.69832 17.4829C5.27832 17.4829 4.93832 17.1429 4.93832 16.7229V10.2529Z"
                                                fill="#FF4747"></path>
                                        </svg>
                                    </button>
                                    <button v-if="props.row.social_publish_status === 'ready_to_publish'" size="sm"
                                        class="btn mr-1 new-view-btn-publish custom-btn" title="Mark as Published"
                                        @click="markAsPublished(props.row.id)">
                                        <!-- Check / Publish Icon -->
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16"
                                            height="16" fill="white">
                                            <path d="M256 8C119 8 8 119 8 256s111 248 248 248
                                                248-111 248-248S393 8 256 8zm121.6 174.1
                                                L234.4 325.3c-4.7 4.7-12.3 4.7-17 0l-83.1-83.1
                                                c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7
                                                17 0l57.6 57.6 118.1-118.1c4.7-4.7 12.3-4.7
                                                17 0l17 17c4.7 4.7 4.7 12.3 0 17z" />
                                        </svg>
                                    </button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue, { set } from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import moment from 'moment'

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            searchTime: null,
            isDisabled: false,
            referralNote: 'Referral Note',
            modalContent: '',
            selected: true,
            unSelected: false,
            currentLanguage: '',
            serverParams: {
                search: "",
                sort: [
                    {
                        field: 'created_at',
                        type: 'desc'
                    }
                ],
                page: 1,
                perPage: 10
            },
            columns: [
                {
                    label: 'Property Type',
                    field: 'property_type',
                    filterable: false,
                    sortable: true
                },
                {
                    label: 'City',
                    field: 'city',
                    sortable: true
                },
                {
                    label: 'State',
                    field: "state",
                    sortable: true
                },
                {
                    label: 'Status',
                    field: "status",
                    sortable: true
                },
                {
                    label: 'Social Publish',
                    field: 'social_publish_status',
                    sortable: true
                },
                {
                    label: 'Action',
                    field: "action",
                    sortable: false,
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: [],
            ReferredBy: new Map(),
            form: {
                ReferredID: '',
            },
        };
    },
    methods: {
        approveProperty(id) {
            this.isLoading = true;
            API.approveProperty(id, res => {
                if (res.status == 200) {
                    this.loadItems();
                    this.$swal({
                        icon: 'success',
                        type: 'success',
                        title: this.$t('alerts.success'),
                        text: res.data.message,
                    })
                } else {
                    this.$swal({
                        icon: 'error',
                        type: 'error',
                        title: this.$t('sweetalert.oops'),
                        text: res.message,
                    })
                }
                this.isLoading = false;
            }, err => {
                console.log(err);
            })
        },
        onSearch() {
            clearTimeout(this.searchTime);
            this.searchTime = setTimeout(() => {
                this.serverParams.page = 1;
                this.loadItems();
            }, 500);
        },
        onSortChange(params) {
            if (params.length > 0) {
                const sort = params[0];
                this.updateParams({
                    sort: [
                        {
                            field: sort.field,
                            type: sort.type,
                        },
                    ],
                });
            } else {
                this.updateParams({ sort: [] });
            }
            this.loadItems();
        },
        updateColumnLabels() {
            this.columns.forEach(col => {
                switch (col.field) {
                    case 'property_type':
                        col.label = this.$t('properties_list.Property_Type');
                        break;
                    case 'city':
                        col.label = this.$t('properties_list.city');
                        break;
                    case 'state':
                        col.label = this.$t('properties_list.state');
                        break;
                    case 'status':
                        col.label = this.$t('property_detail.Status');
                        break;
                    case 'social_publish':
                        col.label = this.$t('property_detail.social_publish');
                        break;
                    case 'action':
                        col.label = this.$t('properties_list.action');
                        break;
                    default:
                        break;
                }
            });
        },
        onLanguageChanged(language) {
            if (language == 'en') {
                this.currentLanguage = '';
            } else {
                this.currentLanguage = '_' + language;
            }

        },
        propertyDetail(id) {
            this.$router.push({ name: 'properties_detail', params: { id: id } });
        },
        deleteProperty(id) {
            this.$swal({
                title: this.$t('sweetalert.Are_you_sure?'),
                text: this.$t('sweetalert.no_revert'),
                type: 'warning',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('sweetalert.yes'),
                cancelButtonText: this.$t('sweetalert.cancel')
            }).then((result) => {
                if (result.value == true) {
                    API.deleteProperty(id, res => {
                        this.loadItems();
                    }, err => {
                        console.log(err);
                    })
                }
            })
        },
        markAsPublished(id) {
            this.isLoading = true;
            API.updateSocialPublishStatus(
                { property_id: id, status: 'published' },
                res => {
                    if (res.status === 200) {
                        this.loadItems();
                        this.$swal({
                            icon: 'success',
                            type: 'success',
                            title: this.$t('sweetalert.updated'),
                            text: this.$t('messages.property_marked_published')
                        });
                    }
                this.isLoading = false;
                },
                err => {
                    this.$swal({
                        icon: 'error',
                        type: 'error',
                        title: this.$t('sweetalert.oops'),
                        text: this.$t('messages.failed_update_status')
                    });
                }
            );
        },
        openReferralModal(row) {
            this.modalContent = row.ReferralNotes;
            this.$refs['referral-modal'].show();
        },
        editMemberStatuss() {
            API.updateRefMemberStatus(this.form,
                data => {
                    this.isDisabled = false;
                    if (data.status === 200) {
                        this.$showNotification(data, "success")
                        this.loadItems();
                    } else {
                        this.errorMsg('Please try again.')
                    }
                },
                err => {
                    this.isDisabled = false;
                    this.errorMsg(err)
                }
            )
        },
        dateFormat(val) {
            return moment(val).format('DD MMMM YYYY')
        },
        loadItems() {
            this.isLoading = true;
            API.getAllPropertiesData(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data;
                    this.isLoading = false;
                }, err => {
                    console.log(err)
                    this.isLoading = false;
                })
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        }
    },
    computed: {
        propertyTypeLabel() {
            return this.$t('properties_list.Property_Type');
        },
        propertycityLabel() {
            return this.$t('properties_list.city');
        },
        propertystateLabel() {
            return this.$t('properties_list.state');
        },
        propertyactionLabel() {
            return this.$t('properties_list.action');
        },
    },
    mounted() {
        this.isLoading = true;
        Vue.prototype.$EventBus.$on('changeLanguage', this.onLanguageChanged);
        Vue.prototype.$EventBus.$on('changeLanguage', this.updateColumnLabels);
        this.loadItems();
        this.updateColumnLabels();
    },
    watch: {
        '$i18n.locale': function (newLocale, oldLocale) {
            this.columns.find(col => col.field === 'property_type').label = this.propertyTypeLabel;
            this.columns.find(col => col.field === 'city').label = this.propertycityLabel;
            this.columns.find(col => col.field === 'state').label = this.propertystateLabel;
            this.columns.find(col => col.field === 'action').label = this.propertyactionLabel;

        }
    }
}
</script>
<style scoped>
button.btn.btn-info {
    padding: 10px !important;
    border-radius: 5px !important;
    font-size: 16px !important;
    line-height: 1 !important;
    height: max-content !important;
}

button.btn.new-primary-btn {
    background: #70D3FF !important;
    border-color: #70D3FF !important;
}
</style>